/* ============================================================
   OUT OFF CAGE — comportamenti
   Nessuna libreria. Usa le API native di Shopify:
   Section Rendering API per carrello e ricerca, Cart AJAX API.
   ============================================================ */
(() => {
  'use strict';
  const $  = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const money = (c) => (window.Shopify?.formatMoney
    ? Shopify.formatMoney(c, window.oocMoneyFormat)
    : new Intl.NumberFormat(document.documentElement.lang || 'it', {
        style: 'currency', currency: window.oocCurrency || 'EUR'
      }).format(c / 100));

  /* ========== 0. La lingua non si perde navigando ==========
     I link interni scritti a mano (impostazioni, testi, menu in basso)
     non hanno il prefisso della lingua (es. /en): navigandoci si
     tornava all'italiano. Qui il prefisso viene aggiunto a tutti. */
  const tieniLingua = (r = document) => {
    const pref = (location.pathname.match(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/i) || [])[0];
    if (!pref) return;
    $$('a[href]', r).forEach(a => {
      const h = a.getAttribute('href');
      if (!h) return;
      if (h.startsWith('/')) {
        if (h === pref || h.startsWith(pref + '/') || h.startsWith('/cdn')) return;
        a.setAttribute('href', pref + h);
      } else if (h.startsWith('http')) {
        /* anche i link scritti per esteso verso il proprio dominio */
        try {
          const u = new URL(h);
          if (u.host !== location.host) return;
          if (u.pathname === pref || u.pathname.startsWith(pref + '/') || u.pathname.startsWith('/cdn')) return;
          a.setAttribute('href', pref + u.pathname + u.search + u.hash);
        } catch (e) {}
      }
    });
  };
  document.addEventListener('DOMContentLoaded', () => tieniLingua());

  /* ========== 1. Testo che sale riga per riga ========== */
  const splitLines = (el, step = 90) => {
    const text = (el.dataset.oocText ??= el.textContent.replace(/\s+/g, ' ').trim());
    el.textContent = '';
    const frag = document.createDocumentFragment();
    const words = text.split(' ').map(w => {
      const s = document.createElement('span');
      s.textContent = w; s.style.display = 'inline-block';
      frag.append(s, document.createTextNode(' '));
      return s;
    });
    el.appendChild(frag);
    const lines = []; let last = null;
    for (const s of words) {
      const top = Math.round(s.offsetTop);
      if (top !== last) { lines.push([]); last = top; }
      lines.at(-1).push(s.textContent);
    }
    el.innerHTML = lines.map((w, i) =>
      `<span class="ln"><i style="transition-delay:${i * step}ms">${w.join(' ')}</i></span>`).join('');
    el.dataset.lines = lines.length;
    el.classList.add('lines');
  };
  window.oocSplitLines = splitLines;


  /* ========== 1b. Testo che si ricompone da caratteri casuali ==========
     Ogni lettera cicla su glifi casuali e poi si "blocca" sulla sua.
     Le lettere si fissano da sinistra a destra: il testo emerge dal rumore. */
  const GLYPHS = '#$%&*+-/<=>?@[]^_~ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const GLYPHS_MIN = 'abcdefghijklmnopqrstuvwxyz0123456789+-<=>*';
  const rnd = () => GLYPHS[(Math.random() * GLYPHS.length) | 0];
  /* stessa cassa del carattere vero: la larghezza balla molto meno */
  const rndPer = (c) => /[a-zà-ù]/.test(c)
    ? GLYPHS_MIN[(Math.random() * GLYPHS_MIN.length) | 0]
    : rnd();

  const shuffleText = (el, opts = {}) => {
    if (el.dataset.busy === '1') return;
    const real = (el.dataset.oocText ??= el.textContent.replace(/\s+/g, ' ').trim());
    const speed = +(opts.speed ?? el.dataset.oocSpeed ?? window.oocFx?.speed ?? 30);   // ms per fotogramma
    const hold  = +(opts.hold  ?? el.dataset.oocHold  ?? 2.2);  // giri prima di fissare
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) { el.textContent = real; return; }

    el.dataset.busy = '1';
    el.classList.add('shuffle--busy');
    /* blocco la scatola: durante l'animazione il testo non si sposta.
       Larghezza, altezza e a-capo fermi: se i caratteri casuali sono più larghi
       non deve andare a capo, sennò trema tutta la riga. */
    const w0 = el.offsetWidth, h0 = el.offsetHeight;
    if (getComputedStyle(el).display === 'inline') el.style.display = 'inline-block';
    if (w0) {
      el.style.minWidth = w0 + 'px'; el.style.maxWidth = w0 + 'px';
      el.style.height = h0 + 'px'; el.style.whiteSpace = 'nowrap'; el.style.overflow = 'hidden';
    }
    const chars = [...real];
    const settleAt = chars.map((c, i) => /\s/.test(c) ? 0 : Math.round(i * hold + Math.random() * hold * 2));
    const total = Math.max(...settleAt) + 1;
    let frame = 0, last = 0;

    const step = (t) => {
      if (t - last < speed) { requestAnimationFrame(step); return; }
      last = t;
      el.textContent = chars.map((c, i) => (frame >= settleAt[i] ? c : rndPer(c))).join('');
      if (frame++ < total) requestAnimationFrame(step);
      else {
        el.textContent = real; el.dataset.busy = '0'; el.classList.remove('shuffle--busy');
        el.style.minWidth = ''; el.style.maxWidth = ''; el.style.display = '';
        el.style.height = ''; el.style.whiteSpace = ''; el.style.overflow = '';
      }
    };
    requestAnimationFrame(step);
  };
  window.oocShuffle = shuffleText;

  const initShuffle = (root = document) => {
    $$('[data-ooc-shuffle]:not([data-ready])', root).forEach(el => {
      el.dataset.ready = '1';
      el.classList.add('shuffle');
      el.dataset.oocText = el.textContent;
      const mode = el.dataset.oocShuffle || 'view';        // view | hover | both | now
      if (mode === 'now') { shuffleText(el); }
      if (mode === 'view' || mode === 'both') {
        const o = new IntersectionObserver((es) => {
          for (const e of es) if (e.isIntersecting) { shuffleText(e.target); o.unobserve(e.target); }
        }, { threshold: .35 });
        o.observe(el);
      }
      if (mode === 'hover' || mode === 'both') {
        const trigger = el.closest('a,button') || el;
        trigger.addEventListener('mouseenter', () => shuffleText(el));
        trigger.addEventListener('focus', () => shuffleText(el));
      }
    });
  };


  /* ========== 1c. Shuffle automatico sui testi piccoli ==========
     Tutto ciò che è micro-testo si ricompone quando entra in vista.
     Restano fuori: campi, contatori che cambiano da soli, e ciò che
     è marcato data-ooc-no-shuffle. */
  const MICRO_SEL = [
    '.micro', '.tile__name', '.tile__meta', '.price',
    '.slide__meta', '.pdp__t', 'h4'
  ].join(',');
  const MICRO_SKIP = [
    '[data-cart-count]', 'input', 'select', 'textarea', 'option',
    '[data-ooc-no-shuffle]', '.drawer', '.pre', '[data-ooc-shuffle]'
  ].join(',');

  const initShuffleAuto = (root = document) => {
    if (!window.oocFx?.microShuffle) return;
    const io2 = new IntersectionObserver((es) => {
      let k = 0;
      for (const e of es) {
        if (!e.isIntersecting) continue;
        const el = e.target;
        io2.unobserve(el);
        setTimeout(() => shuffleText(el, { speed: 26, hold: 1.6 }), (k++) * 45);
      }
    }, { threshold: .6 });

    $$(MICRO_SEL, root).forEach(el => {
      if (el.dataset.autoShuffle === '1') return;
      if (el.closest(MICRO_SKIP)) return;
      if (el.querySelector('*')) return;                 // solo foglie di testo
      const t = el.textContent.trim();
      if (!t || t.length > 42) return;                   // non su testi lunghi
      el.dataset.autoShuffle = '1';
      el.classList.add('shuffle');
      io2.observe(el);
    });
  };

  /* shuffle al passaggio del mouse su link e bottoni */
  const initShuffleHover = (root = document) => {
    if (!window.oocFx?.hoverShuffle) return;
    $$('a,button', root).forEach(a => {
      if (a.dataset.hoverShuffle === '1') return;
      if (a.closest('.pre,[data-ooc-no-shuffle]')) return;
      const target = a.matches(MICRO_SEL) ? a : a.querySelector(MICRO_SEL);
      if (!target || target.querySelector('*')) return;
      const t = target.textContent.trim();
      if (!t || t.length > 32) return;
      a.dataset.hoverShuffle = '1';
      target.classList.add('shuffle');
      target.dataset.oocText = target.textContent;
      a.addEventListener('mouseenter', () => shuffleText(target, { speed: 24, hold: 1.4 }));
      a.addEventListener('focus', () => shuffleText(target, { speed: 24, hold: 1.4 }));
    });
  };

  /* ========== 2. Comparsa allo scroll ========== */
  const io = new IntersectionObserver((es) => {
    for (const e of es) {
      if (!e.isIntersecting) continue;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    }
  }, { threshold: .2, rootMargin: '0px 0px -8% 0px' });

  const initReveal = (root = document) => {
    /* le slide impilate: is-in accende titolo, payoff e bottone */
    $$('.slide:not([data-ready])', root).forEach(el => {
      el.dataset.ready = '1';
      io.observe(el);
    });
    $$('[data-ooc-reveal]:not([data-ready])', root).forEach(el => {
      el.dataset.ready = '1';
      splitLines(el, +(el.dataset.oocStagger || window.oocFxStagger || 90));
      io.observe(el);
    });
    if (window.oocFx && window.oocFx.fade === false) return;
    $$('[data-ooc-fade]:not([data-ready])', root).forEach((el, i) => {
      el.dataset.ready = '1';
      el.classList.add('fade-up');
      el.style.transitionDelay = `${Math.min(i, 6) * 60}ms`;
      io.observe(el);
    });
  };

  /* ========== 3. Testata adattiva ========== */
  const initHeader = () => {
    const hdr = $('.hdr'); if (!hdr) return;
    document.documentElement.style.setProperty('--hdr-h', hdr.offsetHeight + 'px');
    /* La testata decide chiaro/scuro dalla luminosità reale di ciò che
       ha sotto: funziona con qualunque schema colore, senza marcature. */
    const luminanza = (col) => {
      const m = String(col).match(/[\d.]+/g);
      if (!m || m.length < 3) return 1;
      if (m.length > 3 && parseFloat(m[3]) < 0.35) return null;   // trasparente
      const [r, g, b] = m.slice(0, 3).map(v => {
        v = v / 255;
        return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4;
      });
      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    };
    const probe = () => {
      /* campiono appena sotto il bordo dell'header, saltando header e preloader:
         altrimenti il punto cade sul logo stesso e la lettura è sempre «scuro» */
      const y = hdr.getBoundingClientRect().bottom + 6;
      const el = document.elementsFromPoint(innerWidth / 2, y)
        .find(n => !n.closest('.hdr') && !n.closest('.pre'));
      if (!el) return;
      let scuro = !!el.closest('[data-ooc-dark],.on-media');
      if (!scuro) {
        // risalgo finché trovo uno sfondo non trasparente
        for (let n = el; n && n !== document.documentElement; n = n.parentElement) {
          const L = luminanza(getComputedStyle(n).backgroundColor);
          if (L !== null) { scuro = L < 0.42; break; }
        }
        if (el.closest('img,video,picture')) scuro = true;
      }
      hdr.classList.toggle('hdr--light', scuro);
      hdr.classList.toggle('hdr--dark', !scuro);
      hdr.classList.toggle('hdr--solid', !scuro && scrollY > 30);
    };
    addEventListener('scroll', probe, { passive: true });
    addEventListener('resize', probe);
    addEventListener('load', probe);
    probe();

    const nav = $('.hdr__nav', hdr), burger = $('.hdr__burger', hdr);
    const setNav = (open) => {
      nav.classList.toggle('is-open', open);
      burger?.setAttribute('aria-expanded', String(open));
      document.body.style.overflow = open ? 'hidden' : '';
    };
    burger?.addEventListener('click', () => setNav(!nav.classList.contains('is-open')));
    nav?.addEventListener('click', (e) => {
      if (e.target.closest('.hdr__nav-close') || e.target.closest('a')) setNav(false);
    });
    addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav?.classList.contains('is-open')) setNav(false);
    });
  };


  /* ========== 3b. Preloader ==========
     Logo che scende, scritta che si ricompone, poi il velo si apre
     verso l'alto. Si mostra una volta per sessione (impostabile). */
  const initPreloader = () => {
    const pre = $('.pre');
    if (!pre) return;

    const once = pre.dataset.once === 'true';
    if (once && sessionStorage.getItem('ooc-pre') === '1') { pre.remove(); return; }

    const minMs = +(pre.dataset.min || 900);
    const t0 = performance.now();
    document.documentElement.classList.add('pre-lock');
    document.body.classList.add('pre-lock');

    requestAnimationFrame(() => {
      pre.classList.add('is-ready');
      const word = pre.querySelector('[data-ooc-shuffle]');
      if (word) { word.dataset.ready = '1'; word.classList.add('shuffle'); shuffleText(word, { speed: 30, hold: 2.4 }); }
    });

    const bar = pre.querySelector('.pre__bar');
    if (bar) {
      let p = 0;
      const tick = setInterval(() => { p = Math.min(92, p + Math.random() * 14); bar.style.width = p + '%'; }, 160);
      pre.addEventListener('ooc:done', () => clearInterval(tick), { once: true });
    }

    const finish = () => {
      const wait = Math.max(0, minMs - (performance.now() - t0));
      setTimeout(() => {
        if (bar) bar.style.width = '100%';
        pre.dispatchEvent(new Event('ooc:done'));
        pre.classList.add('is-done');
        document.documentElement.classList.remove('pre-lock');
        document.body.classList.remove('pre-lock');
        sessionStorage.setItem('ooc-pre', '1');
        setTimeout(() => { pre.remove(); dispatchEvent(new Event('scroll')); }, 1100);
      }, wait);
    };

    document.readyState === 'complete' ? finish() : addEventListener('load', finish);
    setTimeout(finish, 6000); // rete lenta: non blocchiamo mai davvero
  };

  /* ========== 4. Cassetti (carrello, ricerca, filtri) ========== */
  const openDrawer = (d) => {
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    d.querySelector('input,button,a')?.focus({ preventScroll: true });
  };
  const closeDrawer = (d) => {
    d.classList.remove('is-open');
    if (!$('.drawer.is-open')) document.body.style.overflow = '';
  };
  const initDrawers = () => {
    document.addEventListener('click', (e) => {
      const o = e.target.closest('[data-drawer-open]');
      if (o) { e.preventDefault(); const d = $('#' + o.dataset.drawerOpen); if (d) openDrawer(d); return; }
      if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__veil')) {
        closeDrawer(e.target.closest('.drawer'));
      }
    });
    addEventListener('keydown', (e) => {
      if (e.key === 'Escape') $$('.drawer.is-open').forEach(closeDrawer);
    });
  };

  /* ========== 5. Carrello — Cart AJAX + Section Rendering ========== */
  const refreshCart = async () => {
    const r = await fetch(`${window.Shopify?.routes?.root || '/'}?sections=cart-drawer`);
    const data = await r.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = html.querySelector('#cart-drawer .drawer__inner');
    const cur = $('#cart-drawer .drawer__inner');
    if (fresh && cur) cur.replaceWith(fresh);
    const count = html.querySelector('[data-cart-count]')?.textContent;
    /* rete di sicurezza: il conteggio vero dal carrello, sempre */
    try {
      const c = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js').then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(e => e.textContent = c.item_count);
    } catch (e) { }
    if (count != null) $$('[data-cart-count]').forEach(e => e.textContent = count);
  };

  const initCart = () => {
    // aggiunta al carrello senza ricaricare
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form || form.dataset.noAjax) return;
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      btn?.classList.add('is-busy');
      try {
        const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        if (!res.ok) throw new Error((await res.json()).description || 'errore');
        await refreshCart();
        const d = $('#cart-drawer'); if (d) openDrawer(d);
      } catch (err) {
        form.querySelectorAll('[data-cart-error]').forEach(n => n.textContent = err.message);
      } finally { btn?.classList.remove('is-busy'); }
    });

    // confezione regalo e dati fattura: salvati come attributi del carrello
    document.addEventListener('change', async (e) => {
      const el = e.target.closest('[data-cart-attr],[data-cart-attr-text]');
      if (!el) return;
      const name = el.dataset.cartAttr || el.dataset.cartAttrText;
      const value = el.dataset.cartAttr ? (el.checked ? el.value || 'Sì' : '') : el.value.trim();
      try {
        await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { [name]: value } })
        });
      } catch (err) { }
    });

    // quantità e rimozione
    document.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-qty]');
      if (!b) return;
      e.preventDefault();
      const line = +b.dataset.line, delta = +b.dataset.qty;
      const input = b.parentElement.querySelector('input');
      const q = Math.max(0, (+input.value || 0) + delta);
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: q })
      });
      refreshCart();
    });
    document.addEventListener('click', async (e) => {
      const r = e.target.closest('[data-remove-line]');
      if (!r) return;
      e.preventDefault();
      await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: +r.dataset.removeLine, quantity: 0 })
      });
      refreshCart();
    });
  };

  /* ========== 6. Ricerca predittiva ========== */
  const initSearch = () => {
    const input = $('[data-predictive-input]');
    const out = $('[data-predictive-results]');
    if (!input || !out) return;
    let t, controller;
    input.addEventListener('input', () => {
      clearTimeout(t);
      const q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      t = setTimeout(async () => {
        controller?.abort();
        controller = new AbortController();
        const url = `${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(q)}`
          + `&resources[type]=product,collection,page&resources[limit]=6`
          + `&section_id=predictive-search`;
        try {
          const html = await fetch(url, { signal: controller.signal }).then(r => r.text());
          const doc = new DOMParser().parseFromString(html, 'text/html');
          out.innerHTML = doc.querySelector('[data-predictive-inner]')?.innerHTML || '';
          initReveal(out);
        } catch (_) {}
      }, 220);
    });
  };

  /* ========== 7. Filtri storefront senza ricaricare ========== */
  const initFacets = () => {
    const form = $('[data-facet-form]');
    if (!form) return;
    const apply = async (url) => {
      const html = await fetch(url).then(r => r.text());
      const doc = new DOMParser().parseFromString(html, 'text/html');
      for (const sel of ['[data-facet-form]', '[data-results]', '[data-active-facets]']) {
        const fresh = doc.querySelector(sel), cur = $(sel);
        if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      }
      history.replaceState({}, '', url);
      initReveal($('[data-results]'));
    };
    document.addEventListener('change', (e) => {
      if (!e.target.closest('[data-facet-form]')) return;
      const params = new URLSearchParams(new FormData($('[data-facet-form]')));
      apply(`${location.pathname}?${params}`);
    });
    document.addEventListener('click', (e) => {
      const a = e.target.closest('[data-facet-remove]');
      if (a) { e.preventDefault(); apply(a.href); }
    });
  };


  /* ========== 7b. Privacy ==========
     Shopify gestisce il banner cookie da solo (Impostazioni →
     Privacy dei clienti). Qui aggiungiamo solo due cose:
     il link per riaprire le preferenze, e un evento su cui
     agganciare eventuali script che richiedono il consenso. */
  const initPrivacy = () => {
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-ooc-cookie-prefs]');
      if (!b) return;
      e.preventDefault();
      if (window.privacyBanner?.showPreferences) {
        window.privacyBanner.showPreferences();
      } else if (window.Shopify?.customerPrivacy) {
        // il banner non è attivo: portiamo alla pagina privacy
        location.href = '/policies/privacy-policy';
      }
    });

    // quando il consenso cambia, lo mettiamo su <html> così il CSS
    // e gli script di terze parti possono reagire
    const apply = (c) => {
      const r = document.documentElement;
      r.dataset.consentAnalytics = String(!!c?.analyticsAllowed);
      r.dataset.consentMarketing = String(!!c?.marketingAllowed);
    };
    document.addEventListener('visitorConsentCollected', (e) => apply(e.detail));
    if (window.Shopify?.customerPrivacy) {
      apply({
        analyticsAllowed: Shopify.customerPrivacy.analyticsProcessingAllowed?.(),
        marketingAllowed: Shopify.customerPrivacy.marketingAllowed?.()
      });
    }
  };

  /* ========== 8. Avvio ========== */
  const boot = () => { initPreloader(); initReveal(); initShuffle(); initShuffleAuto(); initShuffleHover(); initHeader(); initDrawers(); initCart(); initSearch(); initFacets(); initPrivacy(); };
  document.readyState === 'loading' ? addEventListener('DOMContentLoaded', boot) : boot();

  let rt;
  addEventListener('resize', () => {
    clearTimeout(rt);
    rt = setTimeout(() => {
      $$('[data-ooc-reveal][data-ready]').forEach(el => {
        const was = el.classList.contains('is-in');
        el.classList.remove('is-in');
        splitLines(el, +(el.dataset.oocStagger || 90));
        if (was) requestAnimationFrame(() => el.classList.add('is-in'));
      });
    }, 200);
  });

  // l'editor del tema ricarica le sezioni al volo
  // eventi dell'editor del tema: le app e i blocchi si riagganciano
  const rebind = (root) => {
    initReveal(root); initShuffle(root); initShuffleAuto(root); initShuffleHover(root);
    initHeader(); initSearch(); initFacets();
  };
  document.addEventListener('shopify:section:load', (e) => rebind(e.target));
  document.addEventListener('shopify:section:unload', () => initHeader());
  document.addEventListener('shopify:section:select', (e) => {
    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  document.addEventListener('shopify:block:select', (e) => {
    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    e.target.closest('.slide')?.classList.add('is-in');
    const d = e.target.closest('.drawer'); if (d) d.classList.add('is-open');
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const d = e.target.closest('.drawer'); if (d && !d.dataset.keep) d.classList.remove('is-open');
  });
})();
